import React from 'react';
import PropTypes from 'prop-types';
import GatsbyLink from 'gatsby-link';

import Heading from '@marvelapp/marvel-ui/heading';
import MarvelLink from '@marvelapp/marvel-ui/link';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Close from 'marketing-website/components/icons/Close';
import Hamburger from 'marketing-website/components/icons/Hamburger';
import devNavLinks from 'marketing-website/configs/devNavLinks.js';

import generalStyles from './style/general.module.css';

/*
 * TODO: unify with desktop version and reuse in both places, no time now
 */
export function isAbsoluteUrl(url) {
  return url.indexOf('://') > 0 || url.indexOf('//') === 0;
}

export default function DevMobileNav({ isOpen, toggleNav, hasScrolled }) {
  const navStyle = {
    top: hasScrolled ? 21 : 26,
    right: 20,
  };
  return (
    <div>
      {isOpen && (
        <div className={generalStyles.linksWrap}>
          <div className={generalStyles.links}>
            {devNavLinks.map(item => {
              const Link = isAbsoluteUrl(item.url) ? MarvelLink : GatsbyLink;
              return (
                <Spacing type="margin" position="bottom" size="l">
                  <Link to={item.url} url={item.url} data-bypass>
                    <MarvelLink url={item.url} data-bypass>
                      <Heading tag="h2" size="xxxl">
                        {item.title}
                      </Heading>
                    </MarvelLink>
                  </Link>
                </Spacing>
              );
            })}
            <Spacing type="margin" position="bottom" size="l">
              <MarvelLink url="https://marvelapp.com/oauth/applications/">
                <Heading tag="h2" size="xxxl">
                  My Applications
                </Heading>
              </MarvelLink>
            </Spacing>
          </div>
        </div>
      )}
      <div className={generalStyles.nav} onClick={toggleNav} style={navStyle}>
        {isOpen ? (
          <Close />
        ) : (
          <div className="fill-white">
            <Hamburger />
          </div>
        )}
      </div>
    </div>
  );
}

DevMobileNav.propTypes = {
  hasScrolled: PropTypes.bool,
  isOpen: PropTypes.bool,
  toggleNav: PropTypes.func.isRequired,
};

DevMobileNav.defaultProps = {
  hasScrolled: false,
  isOpen: false,
};



// WEBPACK FOOTER //
// ./src/components/modules/DevHeader/DevMobileNav/index.js